import { getPrefix } from './getPrefix';

export function getFriendlyArea(area: number | null | undefined, hasPrefix?: boolean): string {
  if (area == null) {
    return '';
  }

  return `${getPrefix(!!hasPrefix)} ${area.toString().replace('.', ',')} м²`.trim();
}
